import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

export const PlanNotAllowReservation = (): JSX.Element => {
  return (
    <Typography variant='content2' center>
      O paciente não possui nenhum convênio que permita a criação da reserva.
    </Typography>
  )
}